// ------------------------------------------------------------------
// MOCK DATA — Kanwal Malik artist website (frontend-only teaser)
// All data below is mocked and will be replaced by backend APIs later.
// ------------------------------------------------------------------

export const SEO_META = {
  home: {
    title: 'Kanwal Malik (KHM) — Singer, Songwriter & Humanitarian',
    description:
      'Official website of Kanwal H. Malik (KHM) — entrepreneur, humanitarian and artist. Discover her music, live events, KHM Cares initiatives and book her for your next event.',
  },
  about: {
    title: 'About KHM — Meet Kanwal H. Malik',
    description:
      'Meet the woman behind KHM — a journey from entrepreneurship and business leadership to humanitarian work and music, giving back through education with The Citizens Foundation.',
  },
  music: {
    title: 'Music — Listen to KHM | MANIFEST Album',
    description:
      'Listen to KHM’s latest releases including the MANIFEST album — Tum, Dekho Sunno, Dost, Bin Tere and more. Stream on Spotify, Apple Music and YouTube.',
  },
  events: {
    title: 'Events — Experience KHM Live',
    description:
      'Upcoming concerts, tours and special appearances by Kanwal Malik, plus past event highlights. Get tickets and book KHM for your next event.',
  },
  csr: {
    title: 'KHM Cares — Music With a Mission',
    description:
      'KHM Cares & KHM Events create impact three ways: supporting partner orphanages, building a TCF school in Karachi and educating 180 students. Donate or partner with us.',
  },
  gallery: {
    title: 'Media & Gallery — Photos, Videos & Highlights',
    description:
      'A visual journey through Kanwal Malik’s performances, portraits and defining moments — photos, videos and highlights from KHM.',
  },
  contact: {
    title: 'Book Kanwal — KHM for Your Next Event',
    description:
      'Book Kanwal Malik (KHM) for concerts, corporate events, private functions, brand collaborations and special appearances. Send a booking request today.',
  },
  privacy: {
    title: 'Privacy Policy — KHM',
    description: 'How Kanwal Malik (KHM) collects, uses and protects your information.',
  },
  terms: {
    title: 'Terms & Conditions — KHM',
    description: 'Terms and conditions for the use of the official Kanwal Malik (KHM) website.',
  },
};


export const NAV_LINKS = [
  { label: 'HOME', href: '/' },
  { label: 'ABOUT KHM', href: '/about' },
  { label: 'MUSIC', href: '/music' },
  { label: 'EVENTS', href: '/events' },
  { label: 'C S R', href: '/csr' },
  { label: 'MEDIA', href: '/gallery' },
];

export const IMAGES = {
  hero: '/assets/khm-hero.jpg',
  about: '/assets/khm-about.jpg',
  live: 'https://images.unsplash.com/photo-1540039155733-5bb30b53aa14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxjb25jZXJ0JTIwY3Jvd2QlMjBsaWdodHN8ZW58MHx8fHwxNzkwMTU4MDAwfDA&ixlib=rb-4.1.0&q=85',
  booking: 'https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHx2aW50YWdlJTIwbWljcm9waG9uZSUyMGJva2VofGVufDB8fHx8MTc5MDE1ODAwMHww&ixlib=rb-4.1.0&q=85',
};

export const SOCIALS = [
  { id: 'instagram', label: 'Instagram', url: 'https://www.instagram.com/beingkhmofficial' },
  { id: 'youtube', label: 'YouTube', url: 'https://www.youtube.com/channel/UCM8bxFuGSRrPH49hbIyQ0ZQ' },
  { id: 'spotify', label: 'Spotify', url: 'https://open.spotify.com/artist/3yGIyg2v9U60TB3bAWLtbv' },
  { id: 'apple', label: 'Apple Music', url: 'https://music.apple.com/us/artist/khm/285214090' },
];

export const RELEASES = [
  {
    id: 'tum',
    title: 'TUM',
    artist: 'Kanwal Malik',
    year: '2026',
    duration: '4:10',
    cover: 'https://i.scdn.co/image/ab67616d0000b273399571924dc9b1994814a334',
    youtubeId: '2NM8cffaFYs',
    spotify: 'https://open.spotify.com/track/5sw6mw5pnCzDlMrDn7j6MY',
    apple: 'https://music.apple.com/us/song/tum/6818210518',
    youtube: 'https://www.youtube.com/watch?v=2NM8cffaFYs&list=OLAK5uy_mfMqkWiO2SVnZ2cU8Ftqiqd-8XF7ZTxLQ',
  },
  {
    id: 'dekho-sunno',
    title: 'DEKHO SUNNO',
    artist: 'Kanwal Malik',
    year: '2026',
    duration: '2:56',
    cover: 'https://i.scdn.co/image/ab67616d0000b273399571924dc9b1994814a334',
    youtubeId: 'XYytTYEFIkA',
    spotify: 'https://open.spotify.com/track/2ljvV2aFBwBPO4bMikFRWj',
    apple: 'https://music.apple.com/us/song/dekho-sunno/6818210520',
    youtube: 'https://www.youtube.com/watch?v=XYytTYEFIkA&list=OLAK5uy_mfMqkWiO2SVnZ2cU8Ftqiqd-8XF7ZTxLQ',
  },
  {
    id: 'dost',
    title: 'DOST',
    artist: 'Kanwal Malik',
    year: '2026',
    duration: '4:13',
    cover: 'https://i.scdn.co/image/ab67616d0000b273399571924dc9b1994814a334',
    youtubeId: 'P6bT1H70WbE',
    spotify: 'https://open.spotify.com/track/6LH8xPyGkPsgfPdpNCt5Hj',
    apple: 'https://music.apple.com/us/song/dost/6818210523',
    youtube: 'https://www.youtube.com/watch?v=P6bT1H70WbE&list=OLAK5uy_mfMqkWiO2SVnZ2cU8Ftqiqd-8XF7ZTxLQ',
  },
  {
    id: 'bin-tere',
    title: 'BIN TERE',
    artist: 'Kanwal Malik',
    year: '2026',
    duration: '5:00',
    cover: 'https://i.scdn.co/image/ab67616d0000b273399571924dc9b1994814a334',
    youtubeId: 'rpV9DpwaygE',
    spotify: 'https://open.spotify.com/track/73mCnchcYG4H4iZx7xiDLh',
    apple: 'https://music.apple.com/us/song/bin-tere/6818210531',
    youtube: 'https://www.youtube.com/watch?v=rpV9DpwaygE&list=OLAK5uy_mfMqkWiO2SVnZ2cU8Ftqiqd-8XF7ZTxLQ',
  },
];

export const ALL_TRACKS = [
  ...RELEASES,
  {
    id: 'tu-chalta-jaa',
    title: 'TU CHALTA JAA',
    artist: 'Kanwal Malik',
    year: '2026',
    duration: '3:01',
    cover: 'https://i.scdn.co/image/ab67616d0000b273399571924dc9b1994814a334',
    youtubeId: 'RZQoNtCslEQ',
    spotify: 'https://open.spotify.com/track/6QE2CaaEPa5rS0dZgQO1G9',
    apple: 'https://music.apple.com/us/song/tu-chalta-jaa/6818210527',
    youtube: 'https://www.youtube.com/watch?v=RZQoNtCslEQ&list=OLAK5uy_mfMqkWiO2SVnZ2cU8Ftqiqd-8XF7ZTxLQ',
  },
  {
    id: 'mann-baanwra',
    title: 'MANN BAANWRA',
    artist: 'Kanwal Malik',
    year: '2026',
    duration: '4:57',
    cover: 'https://i.scdn.co/image/ab67616d0000b273399571924dc9b1994814a334',
    youtubeId: 'gk9ptBY9zXw',
    spotify: 'https://open.spotify.com/track/2O6Vtn6HfKmalGeeiRdHVf',
    apple: 'https://music.apple.com/us/song/mann-baanwra/6818210529',
    youtube: 'https://www.youtube.com/watch?v=gk9ptBY9zXw&list=OLAK5uy_mfMqkWiO2SVnZ2cU8Ftqiqd-8XF7ZTxLQ',
  },
  {
    id: 'tum-acoustic',
    title: 'TUM (ACOUSTIC MIX)',
    artist: 'Kanwal Malik',
    year: '2026',
    duration: '4:04',
    cover: 'https://i.scdn.co/image/ab67616d0000b273399571924dc9b1994814a334',
    youtubeId: 'G039mGqd3QU',
    spotify: 'https://open.spotify.com/track/20EQgkplLOHi4SpMwwHdxv',
    apple: 'https://music.apple.com/us/song/tum-acoustic-mix/6818210627',
    youtube: 'https://www.youtube.com/watch?v=G039mGqd3QU&list=OLAK5uy_mfMqkWiO2SVnZ2cU8Ftqiqd-8XF7ZTxLQ',
  },
];

export const CONCERTS = [
  { city: 'Karachi', venue: 'Arts Council Auditorium', date: 'December 2025', note: 'An evening of originals & classics' },
  { city: 'Lahore', venue: 'Alhamra Open Air Theatre', date: 'October 2025', note: 'KHM Cares benefit concert' },
  { city: 'Islamabad', venue: 'PNCA Auditorium', date: 'August 2025', note: 'Acoustic sessions — sold out' },
  { city: 'Dubai', venue: 'Global Village Main Stage', date: 'March 2025', note: 'International tour opener' },
  { city: 'London', venue: 'The Jazz Café', date: 'November 2024', note: 'Intimate unplugged set' },
];

export const EVENTS = [
  { id: 'karachi-eat', day: '09–11', month: 'JAN 2026', title: 'Karachi Eat 2026', venue: 'Bagh Ibn-e-Qasim Park, near Clifton Beach, Block 3 Clifton, Karachi, Pakistan', ticketUrl: 'https://ticketwala.pk/event/karachi-eat-2026-4787' },
];

export const MORE_EVENTS = [];

export const TICKET_TIERS = [
  { id: 'ga', name: 'GENERAL ADMISSION', price: 'PKR 5,000' },
  { id: 'vip', name: 'VIP', price: 'PKR 15,000' },
  { id: 'golden', name: 'GOLDEN CIRCLE', price: 'PKR 25,000' },
];

export const CSR_INITIATIVES = [
  {
    id: 'orphanages',
    title: 'SUPPORTING PARTNER ORPHANAGES',
    tagline: 'Financial assistance, learning resources and mental well-being support.',
    image: 'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxjaGlsZHJlbiUyMHNtaWxpbmd8ZW58MHx8fHwxNzkwMTU4MDY3fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'tcf-school',
    title: 'BUILD A TCF SCHOOL',
    tagline: 'A $200,000 pledge to build a TCF primary school in Karachi.',
    image: 'https://images.unsplash.com/photo-1524069290683-0457abfe42c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxzY2hvb2wlMjBjaGlsZHJlbnxlbnwwfHx8fDE3OTAzMjg3MDF8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'educate-180',
    title: 'EDUCATE 180 STUDENTS',
    tagline: 'Raising funds to educate 180 students through TCF.',
    image: 'https://images.unsplash.com/photo-1630864972901-052dfdc7fba4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxzY2hvb2xnaXJsJTIwc21pbGluZ3xlbnwwfHx8fDE3OTAxNTgwNjd8MA&ixlib=rb-4.1.0&q=85',
  },
];

export const GALLERY = [
  {
    id: 'g1',
    title: 'Live in Concert',
    tag: 'PERFORMANCE',
    image: 'https://images.pexels.com/photos/16108227/pexels-photo-16108227.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
  {
    id: 'g2',
    title: 'Studio Sessions',
    tag: 'PORTRAIT',
    image: 'https://images.unsplash.com/photo-1506863530036-1efeddceb993?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHx3b21hbiUyMGNpbmVtYXRpYyUyMHBvcnRyYWl0fGVufDB8fHx8MTc5MDE1ODAzNXww&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'g3',
    title: 'On Stage',
    tag: 'PERFORMANCE',
    image: 'https://images.unsplash.com/photo-1579539760267-b2e78d9d735e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHx3b21hbiUyMHN0YWdlJTIwY29uY2VydHxlbnwwfHx8fDE3OTAxNTgwMzV8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'g4',
    title: 'The Crowd',
    tag: 'LIVE',
    image: 'https://images.unsplash.com/photo-1540039155733-5bb30b53aa14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxjb25jZXJ0JTIwY3Jvd2QlMjBsaWdodHN8ZW58MHx8fHwxNzkwMTU4MDAwfDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'g5',
    title: 'Acoustic Evening',
    tag: 'LIVE',
    image: 'https://images.unsplash.com/photo-1615228402326-7adf9a257f2b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxmZW1hbGUlMjBzaW5nZXIlMjBndWl0YXIlMjBzdGFnZXxlbnwwfHx8fDE3OTAxNTgwMDB8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'g6',
    title: 'Portrait Series',
    tag: 'PORTRAIT',
    image: 'https://images.unsplash.com/photo-1552699611-e2c208d5d9cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHx3b21hbiUyMGNpbmVtYXRpYyUyMHBvcnRyYWl0fGVufDB8fHx8MTc5MDE1ODAzNXww&ixlib=rb-4.1.0&q=85',
  },
];

export const BIO = {
  tagline: 'Entrepreneur. Humanitarian. Artist.',
  headingTop: 'MEET THE WOMAN',
  headingBottom: 'BEHIND K H M',
  paragraphs: [
    'Kanwal Malik’s journey is one of ambition, compassion and purpose — evolving from entrepreneurship and business leadership into humanitarian work and, now, music. Throughout her career, she has believed that success carries greater meaning when it creates opportunities for others.',
    'Today, Kanwal is bringing her passion for music together with her commitment to social impact. Through her collaboration with The Citizens Foundation (TCF), she has committed to supporting the development of a school in Karachi and an initiative focused on providing education to 180 students.',
    'As a singer and songwriter, Kanwal envisions her music as more than entertainment. Through her songs, live performances and events, she aims to raise funds and awareness for education and humanitarian causes while bringing people together through shared experiences.',
    'For Kanwal, music is a voice for something greater — a way to connect, inspire and transform passion into meaningful, lasting impact.',
  ],
};

export const EVENT_TYPES = [
  'Concert',
  'Corporate Event',
  'Private Function',
  'Brand Collaboration',
  'Special Appearance',
];

export const LEGAL = {
  privacy: {
    title: 'Privacy Policy',
    body: 'This is a mock privacy policy for the preview build. In the full version, this page will outline how booking enquiries, contact details and media-consent information are collected, stored and protected.',
  },
  terms: {
    title: 'Terms of Use',
    body: 'This is a mock terms page for the preview build. The full version will cover usage of this website, booking terms, cancellation policies and intellectual-property rights for all media showcased here.',
  },
  contact: {
    title: 'Contact',
    body: 'For bookings, collaborations and press: management@kanwalmalik.com — this is mock contact information for the preview build.',
  },
};

// ------------------------------------------------------------------
// ABOUT PAGE (route: /about) — mock content
// ------------------------------------------------------------------

export const ABOUT_NAV = [
  { label: 'HOME', href: '/' },
  { label: 'ABOUT', href: '/about' },
  { label: 'MUSIC', href: '/music' },
  { label: 'EVENTS', href: '/events' },
  { label: 'IMPACT', href: '/#csr' },
  { label: 'GALLERY', href: '/#media' },
  { label: 'CONTACT', href: '/contact' },
];

export const ABOUT_PAGE = {
  hero: {
    label: 'ABOUT KANWAL H MALIK',
    titleLines: ['A Voice Driven', 'by Purpose.'],
    tagline: 'Entrepreneur. Humanitarian. Artist.',
    text: 'Some journeys follow a straight path. Kanwal H. Malik’s never did. Each chapter of her life — from business to humanitarian work and now music — has been connected by one constant: a desire to create, connect and make a meaningful impact.',
    image: '/assets/about-hero.jpg',
  },
  journey: {
    label: 'THE JOURNEY',
    title: 'From Ambition to Impact',
    paragraphs: [
      'Born in Karachi, Kanwal began her professional journey in the world of financial markets before moving into banking, entrepreneurship and business leadership. Over the years, she has built and led ventures across multiple industries, gaining experience in healthcare, real estate, media, investment banking, stock trading, foreign retail franchising and business development.',
      'But somewhere along the way, success began to mean something more — not just what she could build for herself, but what she could help build for others.',
    ],
    collage: [
      '/assets/about-tree.jpg',
      '/assets/khm-about.jpg',
      '/assets/khm-hero.jpg',
      '/assets/khm-live.jpg',
    ],
  },
  humanity: {
    title: 'A HEART FOR HUMANITY',
    paragraphs: [
      'For Kanwal, humanitarian work has never been about being seen. It has been about showing up.',
      'Over the years, she has supported communities through relief efforts, charitable initiatives and social causes across Pakistan. From disaster relief to community development, her experiences have strengthened a belief that continues to shape her life today: real impact begins when compassion becomes action.',
    ],
    image:
      'https://images.pexels.com/photos/4473320/pexels-photo-4473320.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    strip: [
      'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxjaGFyaXR5JTIwY2hpbGRyZW58ZW58MHx8fHwxNzkwMzI4Njk1fDA&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1630864972901-052dfdc7fba4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxzY2hvb2xnaXJsJTIwc21pbGluZ3xlbnwwfHx8fDE3OTAxNTgwNjd8MA&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1524069290683-0457abfe42c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxzY2hvb2wlMjBjaGlsZHJlbnxlbnwwfHx8fDE3OTAzMjg3MDF8MA&ixlib=rb-4.1.0&q=85',
      'https://images.pexels.com/photos/9090750/pexels-photo-9090750.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      'https://images.unsplash.com/photo-1622383563227-04401ab4e5ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHw0fHxwbGFudGluZyUyMHRyZWV8ZW58MHx8fHwxNzkwMTU4MDY3fDA&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1598335624134-5bceb5de202d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxwbGFudGluZyUyMHRyZWV8ZW58MHx8fHwxNzkwMTU4MDY3fDA&ixlib=rb-4.1.0&q=85',
    ],
  },
  education: {
    label: '180 DREAMS   ONE COMMITMENT',
    title: 'Education Changes Everything',
    paragraphs: [
      'Kanwal’s humanitarian journey has now found a new focus: education. Through her collaboration with The Citizens Foundation (TCF), she has committed to supporting the development of a school in Karachi and an initiative focused on educating 180 students.',
      'For Kanwal, these 180 students represent 180 possibilities, 180 futures and 180 opportunities to dream bigger. Her vision is to use her music, live performances and events to bring people together, raise funds and create lasting opportunities for children through education.',
    ],
    image:
      'https://images.unsplash.com/photo-1524069290683-0457abfe42c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxzY2hvb2wlMjBjaGlsZHJlbnxlbnwwfHx8fDE3OTAzMjg3MDF8MA&ixlib=rb-4.1.0&q=85',
    scriptTop: '180 Students',
    scriptBottom: 'Brighter Futures',
    donateUrl:
      'https://fundraise.tcfglobal.org/fundraiser/949423979469/zimmedari-hum-sab-ki-taleem-aur-tarbiyat-ab-ek-saath-an-education-initiative-of-kanwal-malik-for-a-prosperous-pakistan',
  },
  passion: {
    label: 'AND THEN, THERE WAS MUSIC.',
    titleLines: ['A Passion', 'That Found Its Purpose.'],
    paragraphs: [
      'Music has always lived within Kanwal. What was once a personal passion has now become a platform for purpose.',
      'As a singer and songwriter, she sees music as more than entertainment. Through her songs, performances and events, she aims to raise awareness and support education and humanitarian causes, while bringing people together through shared experiences.',
    ],
    image: '/assets/about-blue.jpg',
  },
  music: {
    label: 'HER MUSIC',
    title: 'MANIFEST',
    artistLine: 'by K H M',
    text: 'The debut album — seven songs, each written and composed by Kanwal Malik.',
    cover: 'https://i.scdn.co/image/ab67616d0000b273399571924dc9b1994814a334',
    tracks: [
      { id: 'tum', title: 'Tum', artist: 'Kanwal H. Malik', year: '2026', duration: '4:10', youtubeId: '2NM8cffaFYs', spotify: 'https://open.spotify.com/track/5sw6mw5pnCzDlMrDn7j6MY', apple: 'https://music.apple.com/us/song/tum/6818210518', youtube: 'https://www.youtube.com/watch?v=2NM8cffaFYs&list=OLAK5uy_mfMqkWiO2SVnZ2cU8Ftqiqd-8XF7ZTxLQ' },
      { id: 'dekho-sunno-t', title: 'Dekho Sunno', artist: 'Kanwal H. Malik', year: '2026', duration: '2:56', youtubeId: 'XYytTYEFIkA', spotify: 'https://open.spotify.com/track/2ljvV2aFBwBPO4bMikFRWj', apple: 'https://music.apple.com/us/song/dekho-sunno/6818210520', youtube: 'https://www.youtube.com/watch?v=XYytTYEFIkA&list=OLAK5uy_mfMqkWiO2SVnZ2cU8Ftqiqd-8XF7ZTxLQ' },
      { id: 'dost-t', title: 'Dost', artist: 'Kanwal H. Malik', year: '2026', duration: '4:13', youtubeId: 'P6bT1H70WbE', spotify: 'https://open.spotify.com/track/6LH8xPyGkPsgfPdpNCt5Hj', apple: 'https://music.apple.com/us/song/dost/6818210523', youtube: 'https://www.youtube.com/watch?v=P6bT1H70WbE&list=OLAK5uy_mfMqkWiO2SVnZ2cU8Ftqiqd-8XF7ZTxLQ' },
      { id: 'tu-chalta-jaa-t', title: 'Tu Chalta Jaa', artist: 'Kanwal H. Malik', year: '2026', duration: '3:01', youtubeId: 'RZQoNtCslEQ', spotify: 'https://open.spotify.com/track/6QE2CaaEPa5rS0dZgQO1G9', apple: 'https://music.apple.com/us/song/tu-chalta-jaa/6818210527', youtube: 'https://www.youtube.com/watch?v=RZQoNtCslEQ&list=OLAK5uy_mfMqkWiO2SVnZ2cU8Ftqiqd-8XF7ZTxLQ' },
      { id: 'mann-baanwra-t', title: 'Mann Baanwra', artist: 'Kanwal H. Malik', year: '2026', duration: '4:57', youtubeId: 'gk9ptBY9zXw', spotify: 'https://open.spotify.com/track/2O6Vtn6HfKmalGeeiRdHVf', apple: 'https://music.apple.com/us/song/mann-baanwra/6818210529', youtube: 'https://www.youtube.com/watch?v=gk9ptBY9zXw&list=OLAK5uy_mfMqkWiO2SVnZ2cU8Ftqiqd-8XF7ZTxLQ' },
      { id: 'bin-tere-t', title: 'Bin Tere', artist: 'Kanwal H. Malik', year: '2026', duration: '5:00', youtubeId: 'rpV9DpwaygE', spotify: 'https://open.spotify.com/track/73mCnchcYG4H4iZx7xiDLh', apple: 'https://music.apple.com/us/song/bin-tere/6818210531', youtube: 'https://www.youtube.com/watch?v=rpV9DpwaygE&list=OLAK5uy_mfMqkWiO2SVnZ2cU8Ftqiqd-8XF7ZTxLQ' },
      { id: 'tum-acoustic-t', title: 'Tum (Acoustic Mix)', artist: 'Kanwal H. Malik', year: '2026', duration: '4:04', youtubeId: 'G039mGqd3QU', spotify: 'https://open.spotify.com/track/20EQgkplLOHi4SpMwwHdxv', apple: 'https://music.apple.com/us/song/tum-acoustic-mix/6818210627', youtube: 'https://www.youtube.com/watch?v=G039mGqd3QU&list=OLAK5uy_mfMqkWiO2SVnZ2cU8Ftqiqd-8XF7ZTxLQ' },
    ],
  },
  mission: {
    label: 'MUSIC WITH A MISSION',
    titleLines: ['One Voice.', 'Two Passions.', 'One Purpose.'],
    text: 'Kanwal believes that music and humanitarian work are not separate worlds. Every song creates a connection. Every event creates a gathering. And every gathering creates an opportunity to make a difference.',
    leftImage: '/assets/khm-live.jpg',
    rightImage: '/assets/about-blue.jpg',
  },
  closing: {
    lines: [
      'The entrepreneur in her knows how to build.',
      'The humanitarian knows why it matters.',
      'The artist has found her voice.',
    ],
    statement: 'This is K H M.',
    signature: 'Kanwal H. Malik',
    image: '/assets/about-tree.jpg',
  },
};

export const DONATION_TIERS = [
  { id: 'd1', name: 'SUPPORT A STUDENT', amount: 'PKR 2,500', note: 'School essentials for a month' },
  { id: 'd2', name: 'SPONSOR EDUCATION', amount: 'PKR 15,000', note: 'A full term of learning' },
  { id: 'd3', name: 'BUILD THE SCHOOL', amount: 'PKR 100,000', note: 'Bricks for the Karachi campus' },
];

// ------------------------------------------------------------------
// MUSIC PAGE (route: /music) — mock content
// ------------------------------------------------------------------

export const MUSIC_PAGE = {
  hero: {
    label: 'MUSIC',
    titleLines: ['Listen to K H M'],
    text: ['Original music by Kanwal H. Malik.', 'Listen, watch and experience her latest releases.'],
    image: '/assets/khm-live.jpg',
  },
  releases: [
    {
      id: 'tum-original',
      title: 'TUM',
      version: 'ORIGINAL VERSION',
      credit: 'Written and Composed by Kanwal Malik',
      cover: 'https://i.scdn.co/image/ab67616d0000b273399571924dc9b1994814a334',
      coverScript: 'by K H M',
      youtubeId: '2NM8cffaFYs',
      spotify: 'https://open.spotify.com/track/5sw6mw5pnCzDlMrDn7j6MY',
      apple: 'https://music.apple.com/us/song/tum/6818210518',
      youtube: 'https://www.youtube.com/watch?v=2NM8cffaFYs&list=OLAK5uy_mfMqkWiO2SVnZ2cU8Ftqiqd-8XF7ZTxLQ',
    },
    {
      id: 'tum-acoustic',
      title: 'TUM',
      version: 'ACOUSTIC MIX',
      credit: 'Written and Composed by Kanwal Malik',
      cover: 'https://i.scdn.co/image/ab67616d0000b273399571924dc9b1994814a334',
      coverScript: 'Acoustic',
      youtubeId: 'G039mGqd3QU',
      spotify: 'https://open.spotify.com/track/20EQgkplLOHi4SpMwwHdxv',
      apple: 'https://music.apple.com/us/song/tum-acoustic-mix/6818210627',
      youtube: 'https://www.youtube.com/watch?v=G039mGqd3QU&list=OLAK5uy_mfMqkWiO2SVnZ2cU8Ftqiqd-8XF7ZTxLQ',
    },
    {
      id: 'bin-tere',
      title: 'BIN TERE',
      version: 'FROM MANIFEST',
      credit: 'Written and Composed by Kanwal Malik',
      cover: 'https://i.scdn.co/image/ab67616d0000b273399571924dc9b1994814a334',
      coverScript: 'Bin Tere',
      youtubeId: 'rpV9DpwaygE',
      spotify: 'https://open.spotify.com/track/73mCnchcYG4H4iZx7xiDLh',
      apple: 'https://music.apple.com/us/song/bin-tere/6818210531',
      youtube: 'https://www.youtube.com/watch?v=rpV9DpwaygE&list=OLAK5uy_mfMqkWiO2SVnZ2cU8Ftqiqd-8XF7ZTxLQ',
    },
  ],
  album: {
    label: 'THE ALBUM',
    title: 'MANIFEST',
    meta: 'KHM · POP · 2026 · 7 SONGS · 28 MIN',
    cover: 'https://i.scdn.co/image/ab67616d0000b273399571924dc9b1994814a334',
    spotify: 'https://open.spotify.com/album/0AEDVayC0wnLEGrrIhTjtc',
    apple: 'https://music.apple.com/us/album/manifest/6818210514',
    youtube:
      'https://www.youtube.com/playlist?list=OLAK5uy_mfMqkWiO2SVnZ2cU8Ftqiqd-8XF7ZTxLQ',
    tracks: [
      { id: 't1', num: 1, title: 'Tum', duration: '4:10', youtubeId: '2NM8cffaFYs', spotify: 'https://open.spotify.com/track/5sw6mw5pnCzDlMrDn7j6MY', apple: 'https://music.apple.com/us/song/tum/6818210518', youtube: 'https://www.youtube.com/watch?v=2NM8cffaFYs&list=OLAK5uy_mfMqkWiO2SVnZ2cU8Ftqiqd-8XF7ZTxLQ' },
      { id: 't2', num: 2, title: 'Dekho Sunno', duration: '2:56', youtubeId: 'XYytTYEFIkA', spotify: 'https://open.spotify.com/track/2ljvV2aFBwBPO4bMikFRWj', apple: 'https://music.apple.com/us/song/dekho-sunno/6818210520', youtube: 'https://www.youtube.com/watch?v=XYytTYEFIkA&list=OLAK5uy_mfMqkWiO2SVnZ2cU8Ftqiqd-8XF7ZTxLQ' },
      { id: 't3', num: 3, title: 'Dost', duration: '4:13', youtubeId: 'P6bT1H70WbE', spotify: 'https://open.spotify.com/track/6LH8xPyGkPsgfPdpNCt5Hj', apple: 'https://music.apple.com/us/song/dost/6818210523', youtube: 'https://www.youtube.com/watch?v=P6bT1H70WbE&list=OLAK5uy_mfMqkWiO2SVnZ2cU8Ftqiqd-8XF7ZTxLQ' },
      { id: 't4', num: 4, title: 'Tu Chalta Jaa', duration: '3:01', youtubeId: 'RZQoNtCslEQ', spotify: 'https://open.spotify.com/track/6QE2CaaEPa5rS0dZgQO1G9', apple: 'https://music.apple.com/us/song/tu-chalta-jaa/6818210527', youtube: 'https://www.youtube.com/watch?v=RZQoNtCslEQ&list=OLAK5uy_mfMqkWiO2SVnZ2cU8Ftqiqd-8XF7ZTxLQ' },
      { id: 't5', num: 5, title: 'Mann Baanwra', duration: '4:57', youtubeId: 'gk9ptBY9zXw', spotify: 'https://open.spotify.com/track/2O6Vtn6HfKmalGeeiRdHVf', apple: 'https://music.apple.com/us/song/mann-baanwra/6818210529', youtube: 'https://www.youtube.com/watch?v=gk9ptBY9zXw&list=OLAK5uy_mfMqkWiO2SVnZ2cU8Ftqiqd-8XF7ZTxLQ' },
      { id: 't6', num: 6, title: 'Bin Tere', duration: '5:00', youtubeId: 'rpV9DpwaygE', spotify: 'https://open.spotify.com/track/73mCnchcYG4H4iZx7xiDLh', apple: 'https://music.apple.com/us/song/bin-tere/6818210531', youtube: 'https://www.youtube.com/watch?v=rpV9DpwaygE&list=OLAK5uy_mfMqkWiO2SVnZ2cU8Ftqiqd-8XF7ZTxLQ' },
      { id: 't7', num: 7, title: 'Tum (Acoustic Mix)', duration: '4:04', youtubeId: 'G039mGqd3QU', spotify: 'https://open.spotify.com/track/20EQgkplLOHi4SpMwwHdxv', apple: 'https://music.apple.com/us/song/tum-acoustic-mix/6818210627', youtube: 'https://www.youtube.com/watch?v=G039mGqd3QU&list=OLAK5uy_mfMqkWiO2SVnZ2cU8Ftqiqd-8XF7ZTxLQ' },
    ],
  },
  connect: {
    label: 'STAY CONNECTED',
    text: 'Follow K H M for new music, performances and upcoming releases.',
    image:
      'https://images.unsplash.com/photo-1552699611-e2c208d5d9cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHx3b21hbiUyMGNpbmVtYXRpYyUyMHBvcnRyYWl0fGVufDB8fHx8MTc5MDE1ODAzNXww&ixlib=rb-4.1.0&q=85',
  },
};

// ------------------------------------------------------------------
// EVENTS PAGE (route: /events) — mock content
// ------------------------------------------------------------------

export const EVENTS_PAGE = {
  hero: {
    label: 'EVENTS',
    titleLines: ['Experience K H M Live'],
    text: 'Upcoming concerts, past highlights and special appearances — be part of the experience.',
  },
  upcoming: {
    label: 'LIVE',
    titleLines: ['UPCOMING', 'EVENTS'],
    text: 'Catch Kanwal live at upcoming concerts and special appearances around the world.',
    events: [
      {
        id: 'karachi-eat',
        day: '09–11',
        month: 'JAN 2026',
        title: 'Karachi Eat 2026',
        venue: 'Bagh Ibn-e-Qasim Park, near Clifton Beach, Block 3 Clifton, Karachi, Pakistan',
        ticketUrl: 'https://ticketwala.pk/event/karachi-eat-2026-4787',
      },
    ],
  },
  past: {
    label: 'PAST EVENTS',
    titleLines: ['Moments That', 'Moved Thousands'],
    text: 'A look back at the nights, the lights and the people who made them unforgettable.',
  },
};

// ------------------------------------------------------------------
// BOOK KANWAL PAGE (route: /contact) — mock content
// ------------------------------------------------------------------

export const BOOK_PAGE = {
  hero: {
    label: 'BOOKING',
    titleLines: ['Plan Your Next', 'KHM Event'],
    text: 'From concerts to corporate stages, private functions to brand collaborations — tell us about your event and let’s create something unforgettable.',
    cta: 'SEND A BOOKING REQUEST',
  },
};

// ------------------------------------------------------------------
// GALLERY PAGE (route: /gallery) — mock content
// ------------------------------------------------------------------

export const MEDIA_TABS = ['All', 'Portraits', 'Music Videos', 'Covers', 'Live Performances', 'Podcasts'];

export const GALLERY_PAGE = {
  hero: {
    label: 'MEDIA',
    title: 'Photos, Videos, Podcasts & Highlights',
    text: 'A visual journey through Kanwal’s performances, portraits, podcast appearances and moments that define K H M.',
  },
};

// PORTRAITS — Kanwal's own photographs, displayed at their natural aspect ratio
export const PORTRAITS = [
  { id: 'portrait-riverside', title: 'Riverside', image: '/assets/about-tree.jpg' },
  { id: 'portrait-stage', title: 'Stage Portrait', image: '/assets/about-hero.jpg' },
];

// MUSIC VIDEOS — official videos (BeingKHMofficial on YouTube)
export const MUSIC_VIDEOS = [
  { id: 'mv-dost', youtubeId: '0KqotTVweW8', title: 'DOST (Official Video)', show: 'MUSIC VIDEO · MANIFEST' },
  { id: 'mv-tum', youtubeId: 'vvouP1i7PRM', title: 'TUM (Kanwal Malik)', show: 'MUSIC VIDEO' },
  { id: 'mv-tum-acoustic', youtubeId: 'iMzSViGcAR8', title: 'TUM — Acoustic Version (K.H.M)', show: 'MUSIC VIDEO' },
];

// COVERS — cover songs (YouTube)
export const COVERS = [
  { id: 'cover-shayad', youtubeId: 'b9wqUc65UbM', title: 'Shayad — Arijit Singh (Cover)', show: 'COVER' },
  { id: 'cover-dil-ki-lagi', youtubeId: 'Sqz9QD_ah4Y', title: 'Dil Ki Lagi — Nazia Hasan (Acoustic Cover)', show: 'COVER' },
];

// LIVE PERFORMANCES — gig videos (KHM Films on YouTube)
export const LIVE_VIDEOS = [];

// YouTube helpers — thumbnails come straight from YouTube, no generated art
export const ytThumb = (id) => `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
export const ytWatch = (id) => `https://www.youtube.com/watch?v=${id}`;

// MEDIA PAGE — Podcasts tab (Kanwal's real podcast appearances)
export const PODCASTS = [
  { id: 'pod-hayat', youtubeId: 'J33rsyvxoQg', title: "Pakistan's Trailblazing Entrepreneur: Kanwal Malik's Story", show: 'EXPLORE HAYAT PODCAST' },
  { id: 'pod-faridoon', youtubeId: 'jWDO7PXG6s8', title: '"I Love Challenges, I Am a Risk Taker"', show: 'FARIDOON SHAHRYAR' },
  { id: 'pod-runway', youtubeId: '5y3W_SuZJeA', title: 'Logon Ko Millionaire Banaya Hai Maine', show: 'RUNWAY PODCAST · RUNWAY PAKISTAN' },
];

// HOME — media preview rail: photos, videos, podcasts, highlights
export const HOME_MEDIA = [
  { id: 'hm-portrait', kind: 'photo', tag: 'PHOTOS · PORTRAITS', title: 'The London Eye', image: '/assets/khm-about.jpg' },
  { id: 'hm-video-dost', kind: 'video', tag: 'NEW RELEASE', title: 'Dost — Official Video', youtubeId: '0KqotTVweW8', show: 'K H M · YOUTUBE' },
  { id: 'hm-video', kind: 'video', tag: 'VIDEOS', title: 'Tum — Official Video', youtubeId: '2NM8cffaFYs', show: 'K H M · YOUTUBE' },
  { id: 'hm-podcast', kind: 'podcast', tag: 'PODCASTS', title: "Pakistan's Trailblazing Entrepreneur", youtubeId: 'J33rsyvxoQg', show: 'EXPLORE HAYAT PODCAST' },
  { id: 'hm-highlight', kind: 'photo', tag: 'HIGHLIGHTS', title: 'Live in Concert', image: '/assets/khm-live.jpg' },
  { id: 'hm-portrait-2', kind: 'photo', tag: 'PHOTOS · PORTRAITS', title: 'Riverside', pos: 'top', image: '/assets/about-tree.jpg' },
  { id: 'hm-podcast-2', kind: 'podcast', tag: 'PODCASTS', title: '"I Love Challenges, I Am a Risk Taker"', youtubeId: 'jWDO7PXG6s8', show: 'FARIDOON SHAHRYAR' },
];

// ------------------------------------------------------------------
// LEGAL PAGES (routes: /privacy, /terms) — mock content
// ------------------------------------------------------------------

export const LEGAL_PAGES = {
  privacy: {
    label: 'LEGAL',
    title: 'Privacy Policy',
    updated: 'Last updated: July 2025',
    intro:
      'This is a preview build. The content below is placeholder text describing how K H M would handle your information. It will be finalised with legal counsel before launch.',
    sections: [
      {
        heading: 'Information We Collect',
        body: 'When you submit a booking request or ticket enquiry, we collect the details you provide — such as your name, email, phone number, event type and preferred date. In this preview, these details are stored only in your browser and are not transmitted to any server.',
      },
      {
        heading: 'How We Use Your Information',
        body: 'Information is used solely to respond to booking enquiries, coordinate events and share updates you have requested. We do not sell or rent personal information to third parties.',
      },
      {
        heading: 'Cookies & Analytics',
        body: 'The full site may use privacy-respecting analytics to understand how visitors engage with the music and events, helping us improve the experience. You will be able to manage preferences at any time.',
      },
      {
        heading: 'Your Rights',
        body: 'You may request access to, correction of, or deletion of your personal information at any time by contacting management@kanwalmalik.com.',
      },
      {
        heading: 'Contact',
        body: 'For any privacy-related questions, please reach out to management@kanwalmalik.com. (Mock contact for the preview build.)',
      },
    ],
  },
  terms: {
    label: 'LEGAL',
    title: 'Terms & Conditions',
    updated: 'Last updated: July 2025',
    intro:
      'This is a preview build. The terms below are placeholder text outlining the intended use of this website. They will be finalised with legal counsel before launch.',
    sections: [
      {
        heading: 'Use of This Website',
        body: 'This website and its content are provided for information about Kanwal H. Malik’s music, events and humanitarian work. You agree to use it lawfully and not to disrupt its functionality or misuse any submission forms.',
      },
      {
        heading: 'Bookings & Tickets',
        body: 'Booking requests and ticket reservations made here are enquiries only and do not constitute a confirmed contract until acknowledged in writing by Kanwal’s management team. In this preview, all reservations are stored locally in your browser.',
      },
      {
        heading: 'Intellectual Property',
        body: 'All music, imagery, text and branding on this site are the property of K H M or their respective owners and may not be reproduced without permission.',
      },
      {
        heading: 'Donations',
        body: 'Charitable contributions made through the site are directed toward the stated educational and humanitarian initiatives, including the collaboration with The Citizens Foundation (TCF). Donation processing will be handled by a secure partner in the full version.',
      },
      {
        heading: 'Changes to These Terms',
        body: 'We may update these terms from time to time. Continued use of the website after changes are posted constitutes acceptance of the revised terms.',
      },
    ],
  },
};

// ------------------------------------------------------------------
// CSR PAGE (route: /csr) — mock content
// ------------------------------------------------------------------

export const CSR_PAGE = {
  hero: {
    label: 'KHM CARES · SPREADING JOY',
    title: 'Music With a Mission',
    text: 'KHM Cares is Kanwal’s CSR platform, and KHM Events her event management company. Together, they have initiated three ways to make an impact — turning every gathering into an opportunity to give back.',
  },
  stats: [
    { value: '03', label: 'PARTNER ORPHANAGES' },
    { value: '$200K', label: 'SCHOOL BUILD GOAL' },
    { value: '180', label: 'STUDENTS TO EDUCATE' },
  ],
  causes: [
    {
      id: 'orphanages',
      num: '01',
      title: 'SUPPORTING PARTNER ORPHANAGES',
      text: 'Supporting three partner orphanages by providing them financial assistance, learning resources and mental well-being support.',
      image:
        'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxjaGFyaXR5JTIwY2hpbGRyZW58ZW58MHx8fHwxNzkwMzI4Njk1fDA&ixlib=rb-4.1.0&q=85',
    },
    {
      id: 'tcf-school',
      num: '02',
      title: 'BUILD A TCF SCHOOL',
      donateUrl:
        'https://fundraise.tcfglobal.org/fundraiser/949423979469/zimmedari-hum-sab-ki-taleem-aur-tarbiyat-ab-ek-saath-an-education-initiative-of-kanwal-malik-for-a-prosperous-pakistan',
      text: 'In partnership with The Citizens Foundation (TCF), Kanwal has pledged to raise $200,000 to build a primary school unit in Umar Goth, Baldia Town, Karachi, during the 2026–27 build cycle.',
      image:
        'https://images.unsplash.com/photo-1524069290683-0457abfe42c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxzY2hvb2wlMjBjaGlsZHJlbnxlbnwwfHx8fDE3OTAzMjg3MDF8MA&ixlib=rb-4.1.0&q=85',
    },
    {
      id: 'educate-180',
      num: '03',
      title: 'EDUCATE 180 STUDENTS',
      text: 'Raising funds to educate 180 students through TCF — 180 possibilities, 180 futures and 180 opportunities to dream bigger.',
      image:
        'https://images.unsplash.com/photo-1630864972901-052dfdc7fba4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxzY2hvb2xnaXJsJTIwc21pbGluZ3xlbnwwfHx8fDE3OTAxNTgwNjd8MA&ixlib=rb-4.1.0&q=85',
    },
  ],
  partner: {
    label: 'PARTNER WITH US',
    title: 'Create an Impact Together',
    text: 'Partner with KHM and KHM Events to create an impact together under the banner of KHM Cares.',
  },
};

